import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as postActions from '../../store/action/post'
import _, { result } from 'lodash'
import Link from 'src/components/link'
import Status from '../../components/util/status'
import Date from 'src/components/util/date'
import localStore from 'src/utils/local-storage'
import ImageLoader from '../../components/image-loader/ImageLoader';
import UserAvatar from 'react-user-avatar';
import CacheService from "../../services/CacheService";
import PingService from "../../services/PingService";
import PostService from "../../services/PostService";
import GAService from "../../services/GAService";
import { ToastContainer, toast } from "react-toastify";
import { addNPlayer, emitLockToAllUsers } from '../../Api';
import { udpateLogPost } from '../../utils/common';
import ButtonTrash from './page-list-posts/ButtonTrash';
import ButtonEdit from './page-list-posts/ButtonEdit';
import ButtonAi from './page-list-posts/ButtonAi';
import { getHome } from "../../page/home/utils/helper";
import { convertChannelIdToName } from 'src/utils/convert-channel';
const IMG_SERVER = process.env.REACT_APP_IMG;
const REACT_APP_FE_URL = process.env.REACT_APP_FE_URL;
const REACT_APP_FE_CHANNEL2_URL = process.env.REACT_APP_FE_CHANNEL2_URL || "//showbiz.vn";
class PostItem extends Component {
  isMobile = false;

  constructor(props) {
    super(props);
    this.state = {
      showEdit: false,
      onHover: false,
      isLocking: false,
      postItem: props.postItem,
      contentcreatortype: [],
      config: props.config,
      pageviews: props.postItem.pageviews,
      timeOnPage: props.postItem.timeOnPage,
      showView: true,
      isReviewSEO: false
    };
    this.chooseLayout = this.chooseLayout.bind(this);
    this.copyBtnTextRef = React.createRef();
  }

  componentDidMount() {
    const { login, contentcreatortype, isShowPageViews, isReviewSEO } = this.props;
    const { postItem } = this.state;
    let user = localStore.get('_user');
    //get from BE
    // const showEdit = this.showEditButton(postItem, user) || false;
    const showEdit = postItem.permission ? postItem.permission.can_edit : false;
    const isLocking = this.checkIsLocking(postItem);
    this.setState({
      showEdit,
      contentcreatortype,
      isLocking,
      ...(isShowPageViews !== undefined && {showView: isShowPageViews}),
      ...(isReviewSEO !== undefined && {isReviewSEO: isReviewSEO})
    });
    window.addEventListener('resize', this.chooseLayout);
    emitLockToAllUsers((err, update) => this.actionLockSocket(update));
    this.chooseLayout();
  }

  actionLockSocket(post) {
    let { postItem } = this.state
    if (postItem.id == post.id) {
      this.setState({ postItem: post }, () => this.forceUpdate());
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const showEdit = nextProps.postItem.permission ? nextProps.postItem.permission.can_edit : false;
    this.setState({ postItem: nextProps.postItem, showEdit })
  }

  showEditButton(post, user) {
    const isYourContent = this.isYourContent(post.user, user);
    const isOtherEdit = this.canEditOtherPost(post) || false;
    if (post.editing_status && post.editing) {
      return false;
    }
    if (isYourContent) {
      if ((post.posttype && post.posttype.type_code === 'draft') || isOtherEdit) {
        return true;
      } else {
        return false;
      }
    }
    if (isOtherEdit) {
      if ((post.posttype && post.posttype.type_code === 'draft') || isOtherEdit) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  isYourContent(userPost, user) {
    return userPost._id === user._id || false;
  }

  canEditOtherPost(post) {
    if (post.posttype.type_code == 'ready') {
      return localStore.get('_user').can_edit_publish || false;
    } else {
      return localStore.get('_user').can_edit_other || false;
    }

  }

  checkIsLocking(post) {
    if (post.editing_status && post.editing) {
      return true;
    } else {
      return false
    }

  }

  editPost(post) {
    this.props.setCurrentPost(post);
  }

  hoverRow(status) {
    this.setState({ onHover: status });
  }

  generatePenname = (penname = []) => {
    if (!penname || penname.length === 0) {
      return '-';
    }

    const htmlPenname = penname.map(pn => {
      return (
        `<a href='/posts?penname=${pn.id}&page=1&limit=20' class="d-block">${pn.label}</a>`
      )
    });

    return htmlPenname.join('');
  }

  generateHours = (miliseconds) =>{
    return moment.utc(miliseconds*1000).format('HH:mm:ss');
  }

  generateCategory = (idx, category) => {
    let stringBuilder = [];
    const { config } = this.state;
    let findCat = [];
    let categoryOfObjects = false;
    if (category && category[0] && category[0]._id) {
      categoryOfObjects = true;
    }
    if (!categoryOfObjects) {
      if (config.listCategory) {
        findCat = config.listCategory.filter(cate => category.includes(cate._id));
      }
    } else {
      if (config.listCategory) {
        category = category.map(cate => cate._id);
        findCat = config.listCategory.filter(cate => category.includes(cate._id));
      } else {
        findCat = category;
      }
    }

    findCat.forEach((cat, index) => {
      let name = '';
      if (!this.isMobile) {
        const a = (index === 0) ? '' : '- ';
        name = a + cat.name;
      } else {
        name = cat.name;
      }
      let stringBuilder1 = <a key={`item-category${cat._id}${idx}${index}`} className="mr-1" href={`/posts?category=${cat.url}&page=1&limit=20`}>{name}</a>;
      stringBuilder.push(stringBuilder1);

    });
    return stringBuilder;
  }
  chooseLayout() {
    if (window.innerWidth < 768) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  uppercaseName(phrase) {
    phrase = phrase || "N";
    return phrase
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  updateView(url, postItem){
    console.log(postItem);
    if(!url) {
      toast.error(`Không tìm thấy Bài Viết`);
      return;
    }
    let increment_id;
    const groupId = /-(\d+)\.html/.exec(url);

    if (groupId && groupId[1]) {
      increment_id = groupId[1];
    }

    if(!increment_id) {
      toast.error(`Không tìm thấy Bài Viết`);
      return;
    }
    
    GAService.getViewByID(increment_id).then(
      result => {
        if(result.status){
          toast.success(`Đã Update Pageview cho bài viết: ${postItem.title}`)
          this.setState({
            pageviews: result.pageviews,
            timeOnPage: result.timeOnPage
          })
        }
        else{
          toast.error(`Không Update Pageview cho bài viết`);
        }
      }
    );


  };

  clearCache(url, postItem) {
    const { config: { configuration } } = this.props;
    if (url) {
      const date = moment(postItem.publishedAt);
      let dateString = date.format("YYYY-MM-DD");
      let _frontendurl = _.find(configuration, (conf) => conf.label == "frontendurl");
      let _frontendurlM = _.find(configuration, (conf) => conf.label == "frontendurlm");
      // Khi save Call Get tới URL: https://graph.facebook.com?id=[link cần xóa]&scrape=true
      let urlClear = `?id=${_frontendurl.value + url}&scrape=true`;
      let urlClearM = `?id=${_frontendurlM.value + url}&scrape=true`;

      let urlPing = `?sitemap=${_frontendurl.value + '/post-sitemap-' + dateString + '.xml'}`;


      CacheService.clear(urlClear).then(result =>
        toast.success(`Đã xóa cache cho link: ${result.data.id}`)
      );
      CacheService.clear(urlClearM).then(result =>
        toast.success(`Đã xóa cache cho link: ${result.data.id}`)
      );

      PingService.clear(urlPing).then(result =>
        toast.success(`Đã ping sitemap cho link: ${result.data.id}`)
      );
    } else {
      toast.error(`Không tìm thấy post_url`)
    }
  }

  actionLive(postItem) {
    let params = {
      id: postItem.id,
      _id: postItem._id,
      is_live: !postItem.is_live
    }
    PostService.update(params).then(result => {
      this.setState({ postItem: result }, () => {
        this.clearCache(postItem.post_url, postItem);
      });

    })
  }

  actionTrashPost = () => {
    const { postItem } = this.state;

    this.props.confirmAction({
      message: `Bạn có muốn xóa bài viết này?`,
      onConfirm: async () => {
        const trashStatus = this.state.config.listPosttyle.find(t => t.type_code === 'trash');
        if(!trashStatus) return;
        const home = await getHome();
        let homeCheckIndex = -1;
        console.log(home);
        if(home && 
          (
            home.tiles.find((element, index) => { if(element.post._id === postItem._id && element.type === "manual"){
              homeCheckIndex = index;
              return element;
            }})
          )
          ||
          ( 
            home.tiles.find((element, index) => { 
              if(element.nextPost && element.nextPost._id === postItem._id && element.type === "manual"){
              homeCheckIndex = index;
              return element;
            }})
          )
          
        ){
          this.props.confirmAction({
            message: `Bài viết đang được set trang chủ vị trí ${homeCheckIndex + 1}.`,
            messageConfirm: 'Vui lòng set trang chủ lại.'
            // onConfirm: () => {
            //   postItem.posttype = trashStatus;
            //   postItem.log_action = `${postItem.log_action}${udpateLogPost('đã bỏ rác')}`;
            //   PostService.update(postItem).then(data => {
            //     this.setState({
            //       postItem: data
            //     });
            //   })
            // }
          });
        }
        else{
          postItem.posttype = trashStatus;
          postItem.log_action = `${postItem.log_action}${udpateLogPost('đã bỏ rác')}`;
          PostService.update(postItem).then(data => {
            this.setState({
              postItem: data
            });
          })
        }
      }
    })
  }

  copyLink = (e, postID) => {
    e.target.innerHTML = 'Copied!'
    var textField = document.createElement('textarea')
    textField.innerText = 'https:' + process.env.REACT_APP_HOMEPAGE + '/posts/edit/' + postID
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()

    setTimeout(() => {
      this.copyBtnTextRef.current.innerHTML = '<i className="far fa-copy"></i> Copy'
    }, 4000);
  }

  deleteItem(postId) {
    PostService.deletePost(postId).then(result =>
      console.log(result)

    );
  }
  formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
  }

  highLightKeyword = (text, keyword) => {
    if (!text) return 'Chưa đặt ...';
    if (!keyword) return text;
    const regex = new RegExp(keyword, 'gi');
    return text.replace(regex, (match) => `<span title="Keywords" style="color: darkgreen; font-style: italic;">${match}</span>`);
  }

  render() {
    const { idx, config } = this.props;
    const { postItem, showView, isReviewSEO } = this.state;
    let user = localStore.get('_user');
    let bgColor = postItem.posttype && postItem.posttype.color || '#ffffff';
    const srcAvatarUser = postItem.user && postItem.user.avatar ? (IMG_SERVER + "w60" + '/uploads/' + postItem.user.avatar.hash + postItem.user.avatar.ext) : "";
    const srcAvatarPublisher = (postItem.publisher && postItem.publisher.avatar) ? (IMG_SERVER + "w60" + '/uploads/' + postItem.publisher.avatar.hash + postItem.publisher.avatar.ext) : "";
    let postURL = postItem.post_url;
    if(postURL && postItem.posttype.type_code === 'ready'){
      
      switch(postItem.editor_type){
        case 'video':
          postURL = `/video${postURL.substring(postURL.substring(1).indexOf('/') + 1)}`
          break;
        case 'short':
          postURL = `/video${postURL.substring(postURL.substring(1).indexOf('/') + 1)}`
          break;
        // case 'podcast':
        //   editor_type = '/podcast';
        //   postURL = '/podcast-' + post.post_url.substring(1);
        //   break;
        default:
          postURL = postItem.post_url;
          break;
      }
    }
    // console.log(postItem.editor_type);

    // console.log(postURL);
    if (this.isMobile) {
      return (
        <tr key={`post-${idx}`} onMouseEnter={() => this.hoverRow(true)} onMouseLeave={() => this.hoverRow(false)} className={postItem.posttype.type_code}>
          <td style={{ width: '100%' }} >
            <div className="d-flex">
              <Link to={`/posts/edit/${postItem._id}`} >
                <div className="avatar">
                  {(postItem.img_ver &&
                    <ImageLoader className="lazyload" src={postItem.img_ver} width="100" />) || <img src={process.env.PUBLIC_URL + "/assets/images/100x160.png"} />}
                </div>
              </Link>
              <div className="right">
                <Link to={`/posts/edit/${postItem._id}`} >
                  <h5 className="title">
                    {isReviewSEO
                        ? <div className={'d-flex flex-column'}>
                          <span dangerouslySetInnerHTML={{__html: this.highLightKeyword(postItem.title_google, postItem.keyword)}} style={{ fontSize: '15px' }}/>
                          <span dangerouslySetInnerHTML={{__html: this.highLightKeyword(postItem.description_google, postItem.keyword)}} style={{ fontSize: '12px', fontWeight: 'normal', margin: '4px 0', color: '#424242' }}/>
                        </div>
                        : <div className={'d-flex'}>
                          {/*<span className={`align-items-center flex-column d-flex ${postItem.categories.find(obj => obj.channel == 1) ? "saostar" : "" } ${postItem.categories.find(obj => obj.channel == 2) ? "showbiz" : "" }`}></span>*/}
                          <span style={{ fontSize: '15px' }}>{postItem.title || 'Chưa đặt tên'}</span>
                        </div>
                    }
                    {(postItem.editing_status) && <i className="ml-2 fas fa-lock"></i>}
                  </h5>
                  {
                      postItem.posttype.type_code === 'ready' &&
                      <div className="text-secondary" style={{ fontWeight: 'normal', fontSize: '12px' }}>
                        {showView &&
                            (this.state.pageviews && this.state.pageviews > 0
                                ? <span>View: {this.formatNumber(this.state.pageviews)}</span>
                                : <span>View: Đang cập nhật</span>)
                        }
                        {!isReviewSEO &&
                            (this.state.timeOnPage && this.state.timeOnPage > 0
                                ? <div className={this.props.className}>
                                  <span>Thời gian tr.bình trên trang: </span>
                                  {this.generateHours(this.state.timeOnPage)}
                                </div>
                                : <div></div>)
                        }
                      </div>
                  }
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <div className={`${this.props.hideContentPenname ? 'd-none' : ''}`}>
                    <span className="" style={{ fontSize: "0.8em" }} dangerouslySetInnerHTML={{ __html: this.generatePenname(postItem.contentpenname) }}>
                    </span>
                    </div>
                    <span className="time text-dark">
                    {!isReviewSEO && postItem.posttype && <Date updated_at={postItem.modifiedAt || postItem.updatedAt} published_at={postItem.publishedAt} timeonpage={this.state.timeOnPage} typecode={postItem.posttype.type_code} scheduled={postItem.scheduleAt} />}
                  </span>
                  </div>
                </Link>

                <div className="py-1 cate-name d-flex justify-content-between align-items-center">
                  <div>
                    <span className="mr-1">
                      {postItem.posttype && <Status posttype={postItem.posttype} scheduled={postItem.scheduleAt} />}
                    </span>
                      {postItem.editor_type
                          // && (postItem.editor_type === 'normal' && <button type="button" className="btn btn-sm btn-outline-primary ml-2">Bài thường</button>)
                          && (postItem.editor_type === 'mini' && <button type="button" className="badge badge-danger badge-outlined mr-2">Bài Mini</button>)
                          || (postItem.editor_type === 'special' && <button type="button" className="badge badge-warning badge-outlined mr-2">Bài Special</button>)
                          || (postItem.editor_type === 'video' && <button type="button" className="badge badge-dark badge-outlined mr-2">Bài Video</button>)
                      }

                      {this.generateCategory(idx, postItem.categories)}
                  </div>
                  <div>
                    {postItem.posttype.type_code == 'waiting' && 
                      <ButtonAi postItem={postItem} isMobile={true} />
                    }
                    <button className="btn btn-secondary btn-sm ml-2"
                            style={{padding: '3px 8px', fontSize: '10px'}}
                            onClick={(e) => this.copyLink(e, postItem._id)} ref={this.copyBtnTextRef}>
                      <i className="far fa-copy"></i> Copy
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr >
      );
    }

    return (
      <tr key={`post-${idx}`} onMouseEnter={() => this.hoverRow(true)} onMouseLeave={() => this.hoverRow(false)} className={(postItem.posttype.type_code) + ' h90'}>

        <td className="thumbnail" style={{ width: '135px' }}>
          {(postItem.img_hor &&
            <ImageLoader className="lazyload" src={postItem.img_hor} />) || <img src={process.env.PUBLIC_URL + "assets/images/160x100.png"} />}
        </td>
        <td className="title" >
          <div className='d-flex flex-column'>
            {isReviewSEO
                ? <>
                    <span dangerouslySetInnerHTML={{__html: this.highLightKeyword(postItem.title_google, postItem.keyword)}} style={{ fontSize: '15px' }}/>
                    <span dangerouslySetInnerHTML={{__html: this.highLightKeyword(postItem.description_google, postItem.keyword)}} style={{ fontSize: '12px', fontWeight: 'normal', color: '#424242' }}/>
                  </>
                : <div className={'d-flex'}>
                    {/*<span className={`align-items-center d-flex ${postItem.categories.find(obj => obj.channel == 1) ? "saostar" : "" } ${postItem.categories.find(obj => obj.channel == 2) ? "showbiz" : "" }`}></span>*/}
                    <span style={{ fontSize: '15px' }}>{postItem.title || 'Chưa đặt tên'}</span>
                  </div>
            }
          </div>
          {(postItem.editing_status) && <i className="fas fa-lock"></i>}
          {postItem.editor_type
            // && (postItem.editor_type === 'normal' && <button type="button" className="btn btn-sm btn-outline-primary ml-2">Bài thường</button>)
            && (postItem.editor_type === 'mini' && <button type="button" className="btn btn-sm btn-outline-danger ml-2">Bài Mini</button>)
            || (postItem.editor_type === 'special' && <button type="button" className="btn btn-sm btn-outline-warning ml-2">Bài Special</button>)
            || (postItem.editor_type === 'video' && <button type="button" className="btn btn-sm btn-outline-dark ml-2">Bài Video</button>)
            || (postItem.editor_type === 'podcast' && <button type="button" className="btn btn-sm btn-outline-primary ml-2">Bài Podcast</button>)
            || (postItem.editor_type === 'short' && <button type="button" className="btn btn-sm btn-outline-secondary ml-2">Bài Short</button>)
          }
          {postItem.is_pr && <button type="button" className="btn btn-sm btn-outline-info ml-2">PR</button>}
          {postItem.is_live && <button type="button" className="btn btn-sm btn-outline-success ml-2">Bài Live</button>}

          {
            postItem.posttype.type_code === 'ready' &&
            <div className="text-secondary mt-1" style={{ fontWeight: 'normal', fontSize: '12px' }}>
              {showView &&
                  (this.state.pageviews && this.state.pageviews > 0
                      ? <span>View: {this.formatNumber(this.state.pageviews)}</span>
                      : <span>View: Đang cập nhật</span>)
              }
              {!isReviewSEO &&
                  (this.state.timeOnPage && this.state.timeOnPage > 0
                      ? <div className={this.props.className}>
                          <span>Thời gian tr.bình trên trang: </span>
                          {this.generateHours(this.state.timeOnPage)}
                        </div>
                      : <div></div>)
              }
            </div>
          }

          <div className={"tools tools-posts" + (this.state.onHover ? ' active' : '')}>
            {
              (postItem.editing_status) &&
              <Link to={`/posts/edit/${postItem._id}`}>
                <span className="btn btn-warning btn-sm mr-2" style={{ opacity: "1", pointerEvents: "initial" }}>
                  <i className="fas fa-lock"></i> {postItem.editing && (postItem.editing.fullname || postItem.editing.email)}
                </span>
              </Link>
            }
            {
              // (this.state.showEdit) &&
              <>
                {postItem.posttype.type_code === 'ready' &&
                  <a target="_blank" href={`${postItem.channel == 2 ? REACT_APP_FE_CHANNEL2_URL : REACT_APP_FE_URL}${postURL}`} className="btn btn-info btn-sm mr-2" rel="noopener noreferrer">
                    <i className="fas fa-eye"></i> Xem ngoài trang
                  </a>
                }
                <a target="_blank" href={`/preview/${postItem._id}`} className="btn btn-info btn-sm mr-2" rel="noopener noreferrer">
                  <i className="fas fa-eye"></i> Xem thử
                </a>
                <a target="_blank" href={`/preview/${postItem._id}?isMobile=true`} className="btn btn-info btn-sm mr-2" rel="noopener noreferrer">
                  <i className="fas fa-eye"></i> Xem thử mobile
                </a>

                <button className="btn btn-secondary btn-sm mr-2" onClick={(e) => this.copyLink(e, postItem._id)} ref={this.copyBtnTextRef}>
                  <i className="far fa-copy"></i> Copy
                </button>
                {
                  postItem.posttype.type_code == 'ready' &&
                  <button className="btn btn-warning btn-sm mr-2" onClick={(e) => this.clearCache(postItem.post_url, postItem)}>
                    <i className="far fa-trash-alt"></i> Cache
                </button>
                }
                {
                  postItem.posttype.type_code == 'ready' &&
                  <button className="btn btn-outline-success btn-sm mr-2" onClick={(e) => this.updateView(postItem.post_url, postItem)}>
                    <i className="fas fa-sync"></i> Update View
                </button>
                }
                
                {/* // bai viet da ready thi co the bat live */}
                {
                  (postItem.posttype.type_code == 'ready' && localStore.get('_user').can_live) &&
                  <button className="btn btn-success btn-sm mr-2" onClick={(e) => this.actionLive(postItem)}>
                    <i className="fas fa-wifi"></i> {postItem.is_live ? 'Tắt Live' : 'Bật Live'}
                  </button>
                }

                <ButtonEdit
                  postItem={postItem}
                />
                
                <ButtonTrash
                  postItem={postItem}
                  actionTrashPost={this.actionTrashPost}
                />
                {
                  postItem.posttype.type_code == 'waiting' && 
                  <ButtonAi postItem={postItem} />
                }
                
                {/* && user.id == postItem.user.id  */}
                {/* {
                (user.role.name == 'SuperAdmin' && postItem.posttype.type_code == 'draft') &&
                  <span className="btn btn-danger btn-sm mr-2" onClick={() => this.deleteItem(postItem.id)} >
                    <i className="fas fa-times"></i> Delete
                </span>
                } */}
              </>
            }

          </div>
        </td>

        <td style={{ width: '210px' }}>
          {postItem.posttype &&
            <>
              <Status posttype={postItem.posttype} scheduled={postItem.scheduleAt} />
              {!isReviewSEO && <Date updated_at={postItem.modifiedAt || postItem.updatedAt} timeonpage={this.state.timeOnPage} typecode={postItem.posttype.type_code} published_at={postItem.publishedAt} scheduled={postItem.scheduleAt} />}
            </>
          }
        </td>

        <td style={{ width: '150px' }}>
          <span className="tag tag-success">{this.generateCategory(idx, postItem.categories)}</span>
        </td>

        <td className={`${this.props.hideContentPenname ? 'd-none' : ''} ipad-dis-none`} style={{ width: '150px' }}>
          {postItem.ir_pr
            ? <p>T.H</p>
            : <p dangerouslySetInnerHTML={{ __html: this.generatePenname(postItem.contentpenname) }}></p>
          }

        </td>

        <td style={{ width: '60px', textAlign: 'center' }} className={`user ipad-dis-none ${this.props.hideUser ? 'd-none' : ''}`}>
          {
            <div className="hover-opacity-1" style={{ width: "33px", height: "33px", overflow: "hidden", borderRadius: "999px", margin: "0 auto", opacity: "0.7" }} data-toggle="tooltip" title={'Viết bởi ' + postItem.user.fullname}>
              {postItem.user.avatar
                ? <ImageLoader className="avatar" src={postItem.user.avatar} width="100" />
                : <UserAvatar size="33" name={this.uppercaseName(postItem.user ? postItem.user.fullname : "NN")}
                  src={srcAvatarUser} colors={['#ff6188', '#fc9867', '#ffd866', '#a9dc76', '#78dce8', '#ab9df2']} />
              }
            </div>
          }

          {
            postItem.publisher ?
              <div className="mt-2 hover-opacity-1" style={{ width: "33px", height: "33px", overflow: "hidden", borderRadius: "999px", margin: "0 auto", opacity: "0.7" }} data-toggle="tooltip" title={'Đăng bởi ' + postItem.publisher.fullname}>
                {postItem.publisher.avatar
                  ? <ImageLoader className="avatar" src={postItem.publisher.avatar} width="100" />
                  : <UserAvatar style={{ margin: "0 auto" }} size="33" name={this.uppercaseName(postItem.publisher.fullname)}
                    src={srcAvatarPublisher} colors={['#ff6188', '#fc9867', '#ffd866', '#a9dc76', '#78dce8', '#ab9df2']} />
                }
              </div>
              : '-'
          }
        </td>

        {this.props.showView && postItem.view &&
          <td style={{width: '60px', textAlign: 'center'}}>
            <p dangerouslySetInnerHTML={{__html: postItem.view}}></p>
          </td>
        }
      </tr >
    )
  }

};
export default connect(store => {
  return {
    login: store.loginInfo,
    config: store.config
  };
}, dispatch => {
  return {
    setCurrentPost: (value) => { dispatch(postActions.setCurrentPost(value)) },
    deletePost: (value) => { dispatch(postActions.deletePost(value)) },
  }
})(PostItem)
